import { Time } from 'lightweight-charts';

export function convertToTime(time: string): Time {
  const timeInSeconds = Math.floor(new Date(time).getTime() / 1000);
  // Round to the start of the minute
  const roundedTime = (Math.floor(timeInSeconds / 60) * 60) as Time;

  return roundedTime;
}
